import React, { ReactNode, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Option } from "@shared/interfaces";
import { actions as sharedActions } from "@shared/store";
import { StateIdType } from "@containers/PayPerLead/interface";

import { useCache } from "./CacheProvider";

type StateOption = Option<number | StateIdType>;

export interface StateOptionsProviderProps {
  children: ReactNode;
}

export const StateOptionsProvider = ({ children }: StateOptionsProviderProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sharedActions.getStates.request());
  }, [dispatch]);

  return <>{children}</>;
};

export const useStateOptions = (): StateOption[] => {
  const cache = useCache();

  return useMemo(() => {
    const additionalOption = {
      label: "Nationwide (All States)",
      value: StateIdType.Nationwide,
      abbreviation: "",
      counties: {},
    } as StateOption;

    // Combine cached options with the additional option
    return [additionalOption, ...Object.values(cache.stateOptions).sort((a, b) => a.label.localeCompare(b.label))];
  }, [cache.stateOptions]);
};
